import React from 'react';

import { withAuth } from 'HOC';

import './index.css';


class NoMatchView extends React.Component {
	render() {
		return (
			<div className={'no-match'}>
				<h1>404</h1>
				<h5>Nothing here...</h5>
			</div>
		);
	}
}

export default withAuth(NoMatchView);